// ABOUTME: Modal component that displays a centered loading spinner
// ABOUTME: Used to show loading state during async operations
import { Box, CircularProgress, useTheme } from "@mui/material"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SHModal from "../../theme/Modal/SHModal"
import { tokens } from "../../../theme";
import Text from "../../theme/text/Text";
import Shbutton from "../../theme/buttons/Shbutton";

const MLoader = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return(
        <SHModal
            open={props.open}
            onClose={() => {}}
            showClose={props.responseMessage ? true : false}
            handleClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:6,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                    gap:3,
                    minWidth:300,
                }}>
                {props.responseMessage ? (
                    <>
                        <CheckCircleOutlineIcon
                            sx={{
                                fontSize: 60,
                                color: colors.green[400]
                            }}
                        />
                        <Text center>{props.responseMessage}</Text>
                        <Shbutton
                            onClick={props.handleClose}
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            variant="contained"
                            sx={{ mt: 1 }}
                        >
                            OK
                        </Shbutton>
                    </>
                ) : (
                    <>
                        <CircularProgress
                            size={60}
                            thickness={4}
                            sx={{
                                color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]
                            }}
                        />
                        {props.message && (
                            <Text center light>{props.message}</Text>
                        )}
                    </>
                )}
            </Box>
        </SHModal>
    )
}

export default MLoader;
